@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <div class='text-list-input-container'>
      <div class="fx-column fx-justify-start fx-items-stretch">
        @for (dayObj of serviceDays; track dayObj; let i = $index) {
          <div>
            <div class="fx-row fx-justify-space-between fx-items-center">
              <div class="fx-flex fx-column fx-justify-start fx-items-stretch">
                <label class="content-day">
                  <!-- <mat-icon class='title-input-icon' *ngIf='inputService.formInputDefinition.titleIcon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon> -->
                  <h3><strong>- {{ dayObj.day }}</strong></h3>
                  <span class="starting-time" (click)='addTime(dayObj)'>
                    <i class="material-icons">alarm</i> {{'Aggiungi orario' | translate}}
                  </span>
                </label>
                @for (timeObj of dayObj.time; track timeObj; let i = $index) {
                  <div class="fx-row fx-justify-start fx-items-baseline">
                    <!-- opening time -->
                    <div>
                      <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=50>
                        <mat-label>{{ 'Apertura' | translate }}</mat-label>
                        <input type="time" matInput [name]='dayObj.code + "_start_time_" + i' [(ngModel)]='timeObj.opening' [ngModelOptions]="{standalone: true}" required>
                      </mat-form-field>
                    </div>
                    <!-- end opening time -->
                    <!-- closing times -->
                    <div>
                      <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=50>
                        <mat-label>{{ 'Chiusura' | translate }}</mat-label>
                        <input type="time" matInput [name]='dayObj.code + "_end_time_" + i' [(ngModel)]='timeObj.closure' [ngModelOptions]="{standalone: true}" required>
                      </mat-form-field>
                    </div>
                    <!-- end closing times -->
                    <div class="remove-item">
                      <span class="material-icons" (click)='removeTime(dayObj.time, timeObj)'>delete</span>
                    </div>
                  </div> <!-- Close row -->
                }
              </div>
              <!--
              <button *ngIf='!inputService.inputConfig.readOnly' mat-icon-button color='warn' (click)="removeItem(i)">
                <mat-icon>close</mat-icon>
              </button>
              -->
            </div>
          </div>
        }
      </div>
      <!-- <button *ngIf='!inputService.inputConfig.readOnly' mat-button color='accent' (click)='addNewItem()'>{{'Aggiungi giorni' | translate}}</button> -->
    </div>
  </ng-container>
}